import { Box, Icon } from '@zillow/constellation-10';
import { IconLinkedIn, IconX, IconYouTube } from '@zillow/constellation-icons';
import React from 'react';

import type { SocialLinksProps } from './AuthorPage.types';

/**
 * Displays social media links for the author.
 */
const SOCIAL_CONFIG = [
    {
        key: 'linkedin',
        Glyph: IconLinkedIn,
        label: 'LinkedIn profile',
    },
    {
        key: 'x',
        Glyph: IconX,
        label: 'X (Twitter) profile',
    },
    {
        key: 'youtube',
        Glyph: IconYouTube,
        label: 'YouTube channel',
    },
];

const SocialLinks: React.FC<SocialLinksProps> = ({ socialLinks }) => {
    if (!socialLinks) return null;
    return (
        <Box
            asChild
            css={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 'tighter',
            }}
        >
            <span>
                {SOCIAL_CONFIG.map(({ key, Glyph, label }) => {
                    const href = socialLinks[key as keyof typeof socialLinks];
                    if (!href) return null;
                    return (
                        <Box
                            asChild
                            key={key}
                            css={{
                                display: 'inline-flex',
                                alignItems: 'center',
                            }}
                        >
                            <a
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer nofollow"
                                aria-label={label}
                            >
                                {/* v8 fontColor="textWhite" → white (canonical
                                    COLOR_MAP); the header behind it is fixed dark
                                    blue, so the color must not invert in dark mode. */}
                                <Icon css={{ color: 'white' }}>
                                    <Glyph />
                                </Icon>
                            </a>
                        </Box>
                    );
                })}
            </span>
        </Box>
    );
};

export default SocialLinks;
